import { Coffee } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { CardSkeleton } from './CardSkeleton';

interface IdleUsersCardProps {
  idleUsers: number;
  changeText: string;
  isLoading?: boolean;
}

export const IdleUsersCard: React.FC<IdleUsersCardProps> = ({ idleUsers, changeText, isLoading }) => {
  const { t } = useTranslation('dashboard');

  if (isLoading) {
    return <CardSkeleton />;
  }

  return (
    <div className="bg-card p-6 rounded-lg border shadow-sm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-medium">{t('cards.idleUsers.title')}</h3>
        <Coffee className="w-5 h-5 text-muted-foreground" />
      </div>
      <div className="text-2xl font-bold mb-2">{idleUsers}</div>
      <div className="text-sm text-muted-foreground">{changeText}</div>
    </div>
  );
};
